import { render, staticRenderFns } from "./locdev.vue?vue&type=template&id=20b39dc2&scoped=true"
import script from "./locdev.vue?vue&type=script&lang=js"
export * from "./locdev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b39dc2",
  null
  
)

export default component.exports